import { ISelectItem } from "winfakt-vue-components";

export enum AppBrowse {
	CLIENTS = 1,
	SUPPLIERS = 2,
	PROSPECTS = 3,
	PRODUCTS = 4,
	STOCKIN = 5,
	SALES = 6,
	SALE_ROWS = 7,
	BANK = 8,
	PURCHASES = 9,
	SUBSCRIPTIONS = 10,
	CRM = 11,
	PURCHASE_DOCUMENTS = 12,
	CARS = 13,
	PURCHASE_LEDGERS = 14,
	PROSPECT_DOCUMENTS = 15,
	DIVERSE_LEDGERS = 16,
}

export function getAppBrowseAsSelectItems():ISelectItem<AppBrowse>[]{
	let offset = Object.values(AppBrowse).length / 2;
	return Object.values(AppBrowse).filter(f=>typeof(f)=="string").map((v,i)=>{
		return {
			text: v,
			value: Object.values(AppBrowse)[i+offset] as any as AppBrowse
		};
	});
}